"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminOrganizationComponent = void 0;
const lodash_1 = require("lodash");
//ANGULAR2 BITS
const core_1 = require("@angular/core");
//INTERNAL BITS
const admin_service_1 = require("./admin.service");
const user_service_1 = require("./user.service");
const organizations_service_1 = require("./organizations.service");
const permission_service_1 = require("./permission.service");
const notification_service_1 = require("./notification.service");
const slug_pipe_1 = require("./slug.pipe");
const roles_service_1 = require("./roles.service");
const data_level_service_1 = require("./data-level.service");
let AdminOrganizationComponent = class AdminOrganizationComponent {
    constructor(_talk, _admin, _cd, _user, _organizations, _slug, _permission, _roles, _organization, _dataLevel) {
        this._talk = _talk;
        this._admin = _admin;
        this._cd = _cd;
        this._user = _user;
        this._organizations = _organizations;
        this._slug = _slug;
        this._permission = _permission;
        this._roles = _roles;
        this._organization = _organization;
        this._dataLevel = _dataLevel;
        this.showOrgTypeDropdown = false;
        this.orgModel = { slug: "", displayName: "", roles: [], type: "" };
        this.roleDropDownOrg = [];
        this.organizationsPage = 1;
        this.searchTerm = "";
        this.sortList = "displayName";
        this.sortMod = true;
        this.disableSubmit = true;
    }
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.load();
        });
    }
    reload() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.reloadOrgs();
            yield this.load();
        });
    }
    reloadOrgs() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this._organizations.pull();
        });
    }
    load() {
        this.permission = this._permission.get();
        this.user = this._user.get();
        this.roles = this._roles.get();
        this.dataLevelsDropDown = this._dataLevel.getAll();
        this.organizations = this._organization.get();
        this.organizationsList = (0, lodash_1.cloneDeep)(this.organizations);
        this._organization.getObservable().subscribe({
            next: ({ organizations }) => {
                this.organizations = organizations;
                this.organizationsList = this.filterOrgs(this.searchTerm);
            },
        });
        for (let r in this.roles) {
            if (this.roles[r].type == "org") {
                this.roleDropDownOrg.push({
                    id: this.roles[r].id,
                    name: this.roles[r].displayName,
                    fa: this.roles[r].fa,
                });
            }
        }
    }
    setOrgType(dl) {
        this.orgModel.type = dl.slug;
        this.showOrgTypeDropdown = !this.showOrgTypeDropdown;
    }
    validateOrganizationToCreate(orgToCreate) {
        const { displayName, type, roles } = orgToCreate;
        if (this.organizations.filter(r => displayName.toLowerCase() == r.displayName.toLowerCase()).length) {
            this.broadcastValidationError("It looks like an organization with this name already exists");
            return false;
        }
        else if (roles.length < 1) {
            this.broadcastValidationError("It looks like you did not assign a role to this organization");
            return false;
        }
        else if (displayName.length == 0) {
            this.broadcastValidationError("Organization's name cannot be kept blank.");
            return false;
        }
        else if (displayName.replace(/[^a-zA-Z ]/g, "").length == 0) {
            this.broadcastValidationError("Organization name should not contain all special characters.");
            return false;
        }
        else if (displayName.length > 50) {
            this.broadcastValidationError("Organization's name can have max 50 characters");
            return false;
        }
        else if (!type) {
            this.broadcastValidationError("It looks like you did not select a type for this organization");
            return false;
        }
        return true;
    }
    createOrganization(orgToCreate, form) {
        this.disableSubmit = false;
        orgToCreate.displayName = orgToCreate.displayName.trim();
        const isValidOrg = this.validateOrganizationToCreate(orgToCreate);
        if (isValidOrg) {
            orgToCreate.slug = this._slug.transform(orgToCreate.displayName);
            return this._admin
                .createOrganization(orgToCreate)
                .then(() => this._organizations.pull())
                .then(() => {
                this._cd.markForCheck();
                this._talk.broadcast(`New Organization "${orgToCreate.displayName}" created! <i class="fa fa-smile-o" aria-hidden="true"></i>`);
                this.disableSubmit = true;
                form.resetForm();
            })
                .catch((err) => {
                this.disableSubmit = true;
                this._talk.broadcast(`Oops. There was an issue creating your organization! <i class="fa fa-frown-o" aria-hidden="true"></i><br><br>` +
                    err);
            });
        }
        else {
            this.disableSubmit = true;
        }
    }
    editOrganization(user) {
        let org = user.organization;
        org.organization_roles = user.organization_roles;
        if (!org.organization_roles || org.organization_roles.length < 1) {
            this.broadcastValidationError("It looks like you did not assign a role to this organization");
            return;
        }
        Promise.resolve(this._admin.updateOrganization(org)).then(err => {
            this._user.pull();
            this._organizations.pull();
            this._cd.markForCheck();
            this._talk.broadcast(`Organization updated! <i class="fa fa-smile-o" aria-hidden="true"></i>`);
        });
    }
    broadcastValidationError(message) {
        this._talk.broadcast(`Oops! ${message} <i class="fa fa-smile-o" aria-hidden="true"></i>`);
    }
    sort(sortBy) {
        if (this.sortList === sortBy) {
            this.sortMod = !this.sortMod;
        }
        else {
            this.sortList = sortBy;
            this.sortMod = true;
        }
    }
    sortSign() {
        if (this.sortMod) {
            return "+";
        }
        else {
            return "-";
        }
    }
    onInputSearch(value) {
        this.searchTerm = value;
        this.organizationsList = this.filterOrgs(value);
    }
    filterOrgs(value) {
        let orgs;
        if (value) {
            const valueLowercased = value.toLowerCase();
            orgs = this.organizations.filter(org => 
            // Check organization's displayName
            org.displayName.toLowerCase().includes(valueLowercased) ||
                // Check dfp code displayName and networkCode
                (org.dfpNetworkCodes &&
                    org.dfpNetworkCodes.find(dfp => dfp.displayName.toLowerCase().includes(valueLowercased) ||
                        dfp.networkCode.toLowerCase().includes(valueLowercased))));
        }
        else {
            orgs = this.organizations;
        }
        return (0, lodash_1.cloneDeep)(orgs);
    }
    restoreOrganization(organization) {
        return this._admin
            .restoreOrganization(organization)
            .then(() => __awaiter(this, void 0, void 0, function* () {
            this._talk.broadcast(`Organization restored!`);
            yield this._organizations.pull();
            this._cd.markForCheck();
        }))
            .catch(() => this.broadcastValidationError("Error occurred while restoring organization."));
    }
};
exports.AdminOrganizationComponent = AdminOrganizationComponent;
exports.AdminOrganizationComponent = AdminOrganizationComponent = __decorate([
    (0, core_1.Component)({
        selector: "admin-organization",
        templateUrl: "app/admin-organization.component.html",
        styleUrls: ["styles/admin.component.css"],
    }),
    (0, core_1.Injectable)(),
    __metadata("design:paramtypes", [notification_service_1.NotificationService,
        admin_service_1.AdminService,
        core_1.ChangeDetectorRef,
        user_service_1.UserService,
        organizations_service_1.OrganizationsService,
        slug_pipe_1.SlugPipe,
        permission_service_1.PermissionService,
        roles_service_1.RolesService,
        organizations_service_1.OrganizationsService,
        data_level_service_1.DataLevelService])
], AdminOrganizationComponent);
//# sourceMappingURL=admin-organization.component.js.map